import { render } from "./CreateUserView.vue?vue&type=template&id=7fb0cf6d"
import script from "./CreateUserView.vue?vue&type=script&lang=js"
export * from "./CreateUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__